import React from 'react';
import ReactView from "shared/react_view";
import EventSyncAlert from './../components/EventSyncAlert';
/*
  TODO: This file should be removed when the facebook connect app is converted to Webpacker
 */

export default class EventSyncAlertView extends ReactView {
  constructor(syncErrorMessage, onButtonClick) {
    super(
      <EventSyncAlert
        message={syncErrorMessage}
        onRevert={onButtonClick}
      />
    );
  }
}
